
import {
    Attractions,
    AutoGraph,
    AutoMode,
    CloudOutlined,
    ExploreOutlined,
    LockOutlined,
    PeopleAltOutlined,
    Terminal,
    HomeOutlined
} from '@mui/icons-material';
export const sidebarOptions = [
    {
        Icon: <ExploreOutlined />,
        label: "Explore",
        path: "/explore",
        roles: ["admin", "user"]
    },
    {
        Icon: <HomeOutlined />,
        label: "Home",
        path: "/home",
        roles: ["admin", "user"]
    },
    {
        Icon: <CloudOutlined />,
        label: "Account Factory",
        path: "/account-factory",
        roles: ["admin"],
    },
    {
        Icon: <Attractions />,
        label: "Self-Service Provisioning",
        path: `/provision`,
        roles: ["admin", "user"]
    },
    {
        Icon: <AutoMode />,
        label: "Terraform Automation",
        path: `/state-file`,
        roles: ["admin", "user"],
        subMenu: [
            {
                Icon: <AutoGraph />,
                label: "Automation Assessment",
                path: "/automation-assessment"
            },
            {
                Icon: <Terminal />,
                label: "Migrate to As Code",
                path: "/import"
            },
        ]
    },
    {
        Icon: <LockOutlined />,
        label: "Accounts",
        path: "/accounts",
        roles: ["admin"],
    },
    {
        Icon: <PeopleAltOutlined />,
        label: "Users",
        path: "/users",
        roles: ["admin"],
    },

];
